<template>
    <el-dialog title="请选择您的高考省份和科目" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-province">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <!-- <img src="../assets/images/close.png" alt="关闭" @click="cancelProvinceHandler"> -->
        <h3>省份：</h3>
        <el-row type="flex" justify="space-between">
            <el-button v-for="(item,key) in provinceList" :key="key" :class="activeIndex == key ? 'active-btn' : ''" @click="changeProvince(key)">{{ item.name }}</el-button>
        </el-row>
        <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="高考年份：" prop="year">
                <!-- <h3>高考年份：</h3> -->
                <el-select v-model="form.year" placeholder="请选择高考年份" class="select-year" @change="changeYear">
                    <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <template v-if="form.year">
                <template v-if="Object.values(subjectList).join('').indexOf('文') != -1">
                    <h3>科目类型：</h3>
                    <el-row type="flex" justify="space-between">
                        <el-button v-for="(item,key) in subjectList" :key="key" :class="activeIndex1 == key ? 'active-btn' : ''" @click="changeSubject(key)">{{ item }}</el-button>
                    </el-row>
                </template>
                <template v-else>
                    <h3>首选科目:<span>（物理、历史任选1门，必选）</span></h3>
                    <el-row type="flex">
                        <el-button class="btn-view" v-for="(item,key) in subjectList" :key="key" :class="activeIndex1 == key ? 'active-btn' : ''" @click="changeSubject(key)">{{ item.name }}</el-button>
                    </el-row>
                    <h3>
                        再选科目
                        <span>（任意选择2个再选科目，必选）</span>
                    </h3>
                    <el-form-item prop="subject_name">
                        <el-checkbox-group v-model="form.subject_name" :max="2">
                            <el-checkbox v-for="(item, index) in course_list" :key="index" :label="item">
                                {{ item }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </template>
            </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="changeProvinceHandler">提交</el-button>
            <h3>提示：</h3>
            <p>请慎重选择，提交之后省份和科目类型不可修改！</p>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { getArea } from '@/api/home'

export default {
    data () {
        return {
            provinceList: {},
            subjectList: {},
            activeIndex: 0,
            activeIndex1: 0,
            activeKey1: '',
            options: [],
            form: {
                year: '',
                subject_name: []
            },
            course_list: ['化学','生物','政治','地理'],
            time: new Date().getFullYear(),
            areaInfo: {},
            rules: {
                year: [
                    { required: true, message: '请选择高考年份', trigger: 'change' }
                ],
                subject_name: [
                    { required: true, message: '请选择科目', trigger: 'blur'}, {
                      validator: (rule, value, callback) => {
                        if (value.length !== 2) {
                          callback(new Error('请选择两个科目'));
                        } else {
                          callback();
                        }
                      },
                      trigger: 'blur'
                    }
                ]
            }
        }
        
    },
    computed: { 
		...mapState({
            token: state => state.user.token,
            provinceCode: state => state.user.provinceCode,
            localTypeId: state => state.user.localTypeId,
            year: state => state.user.year
		}),
    },
    watch: {
      provinceCode() {
        this.handleChangeArea()
      },
      localTypeId() {
        this.handleChangeArea()
      }
    },
    methods: {
        cancelProvinceHandler() {
            this.$store.commit('user/SHOWPROVINCE', false);
            localStorage.setItem('isProvince', 'false');
        },
        changeProvince(key) {
            this.activeIndex = key;
            this.subjectList = this.provinceList[key].local_type_id;
            this.activeIndex1 = 0;
            this.form.subject_name = []
        },
        changeSubject(key) {
            this.activeIndex1 = key;
        },
        changeProvinceHandler() {
            this.$refs.form.validate((valid) => {
                 if (valid) {
                    let subject_name = ''
                    if(this.form.subject_name.length > 0) {
                        subject_name = this.subjectList[this.activeIndex1].name + ',' + this.form.subject_name.join(',')
                    } else {
                        subject_name = this.subjectList[this.activeIndex1].name
                    }
                    this.$store.commit('user/CHANGEPROVINCE', this.provinceList[this.activeIndex].area);
                    this.$store.commit('user/CHANGELOCALTYPEID', this.subjectList[this.activeIndex1].local_type);
                    this.$store.commit('user/CHANGESUBJECT', subject_name);
                    this.$store.commit('user/CHANGEYEAR', this.form.year);
                    localStorage.setItem('isProvince', 'true');
                    this.$store.commit('user/SHOWPROVINCE', false);
                    if(this.token) {
                        this.$store.commit('user/SAVEAREA')
                    }  
                }
            })
        },
        changeYear(value) {
        //     getArea(this.form.year).then(res => {
        //         sessionStorage.setItem('areaInfo', JSON.stringify(res.data))
        //         sessionStorage.setItem('proInfo', JSON.stringify(res.data))
        //         this.areaInfo = res.data
        //         this.handleChangeArea()
        //   })
        },
        handleChangeArea() {
            const tmp = this.areaInfo.filter(val => { return val.area === this.provinceCode})
            const batchList = tmp[0].local_batch_id
            const subjectList = tmp[0].local_type_id
            const subjectObj = {}
            const batchObj = {}
            subjectList.map(item => {
                subjectObj[item.local_type] = item
            })
            batchList.map(item => {
                batchObj[item.local_batch_id] = item
            })
            this.$store.commit('user/CHANGPRO', true);
            sessionStorage.setItem('batchObj', JSON.stringify(batchObj))
            sessionStorage.setItem('batchList', JSON.stringify(batchList))
            sessionStorage.setItem('subjectObj', JSON.stringify(subjectObj))
            sessionStorage.setItem('subjectList', JSON.stringify(subjectList))
            this.getAreaHandler()
        },
        getAreaHandler(flag) {
            this.provinceList = JSON.parse(sessionStorage.getItem('proInfo'));
            if(flag) {
                this.activeIndex = 0;
            }
            this.subjectList = this.provinceList[this.activeIndex].local_type_id;
        }
    },
    mounted () {
        if(new Date().getMonth() > 7) {
            this.time = (new Date().getFullYear()) + 1
        }
        for(let i = 0; i <= 6; i++) {
            this.options.push(this.time + i)
        }
        this.getAreaHandler(true)
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    h3 {
        font-size: 16px;
        font-weight: 400;
        color: #2c2e33;
        line-height: 22px;
        margin: 0;
        margin-bottom: 16px;
        text-align: left!important;
        span {
            color: #FF933D;
        }
    }
    p {
        text-align: left!important;
        margin-top: -6px;
        line-height: 22px;
    }
    .el-dialog button {
        width: 240px;
        height: 52px!important;
        background: transparent!important;
        border: 1px solid #e1e4eb!important;
        border-radius: 8px!important;
        position: relative!important;
        z-index: 999!important;
        margin-bottom: 20px!important;
        color: #5e6166!important;
        font-weight: 400!important;
        font-size: 16px!important;
    }
    .el-dialog .active-btn {
        background: #fff6f3!important;
        border: 1px solid $common-color!important;
        color: $common-color!important;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 496px!important;
            height: 52px;
            border: none!important;
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border-radius: 8px;
            margin: 0 auto;
            margin-bottom: 32px!important;
            font-size: 18px!important;
            color: #ffffff!important;
            position: absolute;
            // bottom: 40px;
            left: 50%;
            border: none;
            transform: translateX(-50%);
            font-weight: 400;
            margin-top: 10px;
        }
    }
}
::v-deep .select-year {
    border: 1px solid #e1e4eb!important;
    width: 100%;
    padding-left: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    height: 50px;
    line-height: 50px!important;
    .el-input {
        border: none!important;
    }
    .el-input__icon {
        line-height: 50px!important;
    }
}
::v-deep .el-dialog {
    .el-form-item__label {
        font-size: 16px;
        font-weight: 400;
        color: #2c2e33;
        line-height: 22px;
        margin: 0;
        margin-bottom: 16px;
        text-align: left!important;
    }
    .el-form-item {
        width: 496px!important;
        height: auto!important;
        border: none!important;
        border-radius: 0!important;
        padding: 0!important;
        line-height: 52px!important;
    }
    .el-input.is-focus .el-input__inner, .el-form-item.is-error .el-input__inner {
        border: none!important;
    }
    min-height: 500px!important;
    height: auto!important;
    .btn-view {
        width: 110px!important;
        margin-right: 4px!important;
    }
    .el-checkbox {
        width: 110px!important;
        height: 52px!important;
        background: transparent!important;
        border: 1px solid #e1e4eb!important;
        border-radius: 8px!important;
        position: relative!important;
        z-index: 999!important;
        color: #5e6166!important;
        font-weight: 400!important;
        font-size: 16px!important;
        line-height: 52px;
        text-align: center;
        margin-right: 16px!important;
    }
    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border: 1px solid #DCDFE6!important;
    }
    .el-checkbox:last-child {
        margin-right: 0!important;
    }
    .el-checkbox__label {
        font-size: 16px;
    }
    .el-checkbox__inner::after {
        top: 3px;
        left: 7px;
        height: 8px;
        width: 4px;
    }
    .el-checkbox.is-checked {
        background: #fff6f3!important;
        border: 1px solid #ff6524!important;
        .el-checkbox__inner {
            background: #ff6524 !important;
            border: 1px solid #ff6524 !important;
        }
        
        .el-checkbox__label {
            color: #ff6524;
        }
    }
}
</style>